import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ClientLoaderService } from '../core/util/client-loader.service';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentGuard implements CanActivate {

  constructor(
    private router: Router,
    private clientLoader: ClientLoaderService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const currentClient = await this.clientLoader.getClientName();

    const allowedClients = route.data['allowedClients'] as Array<string>;

    if (!allowedClients || allowedClients.length === 0) {
      return true;
    }

    if (allowedClients.includes(currentClient)) {
      return true;
    }

    this.router.navigate(['inicio']);
    return false;
  }
}